/**
 * Monaco Editor Loader Configuration
 *
 * Configures Monaco Editor to load from our CDN proxy in deployed environments,
 * which caches jsDelivr responses through GCP Cloud CDN.
 *
 * Architecture:
 * - devr41.com, qar41.com, recruit41.com: /recruit41-cdn/* -> GCP Load Balancer -> Cloud CDN -> jsDelivr
 * - localr41.com, locall41.com: Direct to jsDelivr (local nginx doesn't have the proxy)
 *
 * This must be imported before any Monaco Editor components are rendered.
 */
import { loader } from "@monaco-editor/react";

const MONACO_VERSION = "0.52.2";
const JSDELIVR_CDN = `https://cdn.jsdelivr.net/npm/monaco-editor@${MONACO_VERSION}/min/vs`;
const PROXY_CDN = `/recruit41-cdn/npm/monaco-editor@${MONACO_VERSION}/min/vs`;

/**
 * Determine Monaco CDN path based on current domain.
 * Matches the pattern used in useTenant.ts for environment detection.
 */
function getMonacoCdnBase(): string {
  const hostname = window.location.hostname;
  const parts = hostname.split(".");
  const baseDomain = parts.length >= 2 ? parts.slice(-2).join(".") : hostname;

  // Local development doesn't have the CDN proxy in nginx
  // Use direct jsDelivr for localr41.com and locall41.com
  if (baseDomain === "localr41.com" || baseDomain === "locall41.com") {
    return JSDELIVR_CDN;
  }

  // Deployed environments (devr41.com, devl41.com, qar41.com, qal41.com, recruit41.com, learn41.com) use the CDN proxy
  return PROXY_CDN;
}

const MONACO_CDN_BASE = getMonacoCdnBase();

loader.config({
  paths: { vs: MONACO_CDN_BASE },
});

// Log which CDN source is being used (helpful for debugging in dev environments)
const hostname = window.location.hostname;
if (hostname.includes("localr41.com") || hostname.includes("locall41.com") || hostname.includes("devr41.com") || hostname.includes("devl41.com")) {
  console.log(`[Monaco] Loading from: ${MONACO_CDN_BASE}`);
}
